"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function PagerButton(props) {
    var enabledClass = props.pageButton.enabled ? '' : 'pure-button-disabled';
    var dottedClass = props.pageButton.isDotted ? 'page-dotted' : '';
    var selectedClass = props.pageButton.isSelected ? 'page-selected' : '';
    var buttonClasses = ("pure-button page-button " + enabledClass + " " + dottedClass + " " + selectedClass).trim();
    return (React.createElement("button", { className: buttonClasses, onClick: function () { return props.model.goToPage(props.pageButton); } }, props.pageButton.pageNumberDisplay));
}
exports.PagerButton = PagerButton;
var Pager = /** @class */ (function (_super) {
    __extends(Pager, _super);
    function Pager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handlePreviousPageClicked = function () {
            _this.props.model.goToPreviousPage();
        };
        _this.handleNextPageClicked = function () {
            _this.props.model.goToNextPage();
        };
        return _this;
    }
    Pager.prototype.render = function () {
        var _this = this;
        if (!this.props.model.visible) {
            return null;
        }
        var previousPageClasses = ("pure-button page-button previous-page " + (this.props.model.previousPageEnabled ? '' : 'pure-button-disabled')).trim();
        var nextPageClasses = ("pure-button page-button next-page " + (this.props.model.nextPageEnabled ? '' : 'pure-button-disabled')).trim();
        var pagerButtons = this.props.model.pageButtons.map(function (button, index) {
            return React.createElement(PagerButton, { pageButton: button, model: _this.props.model, key: "page-button-" + index });
        });
        var pager = (React.createElement("div", { className: 'pager' },
            React.createElement("button", { className: previousPageClasses, title: 'Previous Page', onClick: this.handlePreviousPageClicked, key: 'page-button-prev' }),
            pagerButtons,
            React.createElement("button", { className: nextPageClasses, title: 'Next Page', onClick: this.handleNextPageClicked, key: 'page-button-next' })));
        return pager;
    };
    return Pager;
}(React.PureComponent));
exports.Pager = Pager;
